import { staticMediaFor } from '@/content/media'
import type { Database, MediaType } from '@/types/database'

export type MediaItem = Database['public']['Tables']['media_items']['Row']

interface Options {
  type?: MediaType
  limit?: number
}

interface State {
  items: MediaItem[]
  loading: boolean
  error: string | null
}

/**
 * Learning Hub content. Served from the client-provided static set (updated by
 * email, not a CMS) so it renders instantly and is immune to the Supabase
 * project idling/pausing. Keeps the async-looking interface so Media.tsx is
 * unchanged.
 */
export function useMediaItems({ type, limit }: Options = {}): State {
  return { items: staticMediaFor(type, limit), loading: false, error: null }
}
